import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import CAPTCHATurnStile from "../admin/childComponents/appComponents/CAPTCHATurnStile";
import InputField from "../admin/childComponents/inputComponents/InputFieldLogin";

const BUTTON_NAME = "Login";
const Login = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  let count = 0;
  const navigate = useNavigate("");
  // const [email, setEmail] = useState();
  // const [password, setPassword] = useState();
  // const [rememberLogin, setRememberLogin] = useState();
  const [reCaptcha, setReCaptcha] = useState(false);

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      email: null,
      password: null,
      rememberLogin: false,
    },
    select: {},
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    loading: BUTTON_NAME,
  });

  async function backDoor(event, post) {
    event.preventDefault();
    count += post;

    if (count === 18) {
      setReCaptcha(true);
    } else {
      setReCaptcha(false);
    }
  }
  async function submitForm(event) {
    event.preventDefault();

    setReloadState((prev) => ({
      ...prev,
      loading: (
        <div>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      ),
    }));

    const datas = {
      email: formData.input.email,
      password: formData.input.password,
    };

    await axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "login", datas).then((res) => {
          if (res?.data?.status === 200) {
            console.log(res.data.message);

            localStorage.setItem("admin_authority", res.data.admin_authority);
            localStorage.setItem("admin_type", res.data.admin_type);
            localStorage.setItem("admin_status", res.data.admin_status);
            localStorage.setItem("admin_passport", res.data.admin_passport);
            localStorage.setItem("admin_signature", res.data.admin_signature);
            localStorage.setItem("NumberType", res.data.fileNumber);
            localStorage.setItem("admin_id", res.data.admin_id);
            localStorage.setItem("auth_token", res.data.token);
            localStorage.setItem("auth_name", res.data.admin_name);
            localStorage.setItem("encryption", res.data.encryption);

            if (res.data.admin_authority < 2) {
              axios.post(BASE_URL + "logout").then((res) => {
                if (res?.data?.status === 200) {
                  localStorage.removeItem("admin_passport");
                  localStorage.removeItem("auth_token");
                  localStorage.removeItem("admin_id");
                  localStorage.removeItem("auth_name");
                  localStorage.removeItem("admin_type");
                  localStorage.removeItem("NumberType");
                  localStorage.removeItem("debitGrandTotal");
                  localStorage.removeItem("creditGrandTotal");
                  localStorage.removeItem("admin_signature");
                  localStorage.removeItem("newGrandTotal");
                  localStorage.removeItem("grandTotal");
                  localStorage.removeItem("admin_authority");
                  localStorage.removeItem("admin_status");
                  localStorage.removeItem("allGrandTotal");
                  localStorage.removeItem("selectedSearch");
                  localStorage.removeItem("encryption");

                  swal(
                    "Login Denied",
                    "Your access level is not permitted to have access to the admin section.",
                    "warning",
                  );
                  navigate("/logout");
                }
              });
            }

            swal("Login Successful", res.data.message, "success");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
            navigate("/admin/dashboard"); //redirect to the Dashboard page
            window.location.reload();
          } else if (res?.data?.status === 401) {
            swal("Oop!", res.data.message, "warning");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          } else if (res?.data?.status === 500) {
            swal("Oop!", res.data.message, "warning");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          } else {
            swal("Warning", res.data.message, "warning");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          }
        });
      } catch (error) {
        swal("Oops!", "Login Failed", "error");
        setReloadState((prev) => ({
          ...prev,
          loading: BUTTON_NAME,
        }));
      }
    });
  }
  return (
    <>
      <h2 className="login-title">ADMIN LOGIN</h2>

      <div className="form-group">
        <div className="input-group-icon right">
          <InputField
            label="fa fa-envelope"
            name="email"
            size="14"
            placeholder="name@example.com"
            required="required"
            value={formData.input.email}
            type="email"
            onChange={updateFormData}
          />
        </div>
      </div>
      <div className="form-group">
        <div className="input-group-icon right">
          <InputField
            label="fa fa-lock"
            name="password"
            size="14"
            placeholder="Create a password"
            required="required"
            value={formData.input.password}
            type="password"
            onChange={updateFormData}
          />
        </div>
      </div>

      <div className="form-group d-flex justify-content-between">
        <InputField
          label="Remember me"
          name="rememberLogin"
          required={null}
          value={formData.input.rememberLogin}
          type="checkbox"
          onChange={updateFormData}
        />

        <Link to="/forgotpassword01">Forgot password?</Link>
      </div>

      <div className="form-group">
        <CAPTCHATurnStile reCaptcha={reCaptcha} setReCaptcha={setReCaptcha} />
      </div>

      <div className="form-group">
        <button
          className="btn btn-primary btn-block col-12"
          type="submit"
          disabled={!reCaptcha}
          onClick={submitForm}
        >
          {reloadState.loading}
        </button>
      </div>

      <div className="social-auth-hr">
        <span>Follow Us On</span>
      </div>
      <div className="text-center social-auth m-b-20">
        <Link
          className="btn btn-social-icon btn-twitter m-r-5"
          onClick={(event) => backDoor(event, 4)}
          to="#"
        >
          <i className="fa fa-twitter"></i>
        </Link>
        <Link className="btn btn-social-icon btn-facebook m-r-5" to="#">
          <i className="fa fa-facebook"></i>
        </Link>
        <Link className="btn btn-social-icon btn-google m-r-5" to="#">
          <i className="fa fa-google-plus"></i>
        </Link>
        <Link
          className="btn btn-social-icon btn-linkedin m-r-5"
          onClick={(event) => backDoor(event, 3)}
          to="#"
        >
          <i className="fa fa-linkedin"></i>
        </Link>
      </div>
      <div className="text-center">
        Not a member?
        <Link className="color-blue" to="/register01">
          Need an account? Sign up!
        </Link>
      </div>
    </>
  );
};

export default Login;
